import { createReducer } from '@reduxjs/toolkit'

import { selectPercent } from './actions'

export interface BurnIslandState {
  readonly percent: number
}

const initialState: BurnIslandState = {
  percent: 0,
}

export default createReducer<BurnIslandState>(initialState, (builder) =>
  builder.addCase(selectPercent, (state, { payload: { percent } }) => {
    return {
      ...state,
      percent,
    }
  })
)
